<template>
  <div>
    <div class="banner-business-menu"></div>
    <div data-v-249f9abc="" class="wrapper clearfix">

      <div data-v-249f9abc="" class="content clearfix">
        <div data-v-24ee54cc="" class="side-nav">
          <div data-v-24ee54cc="" class="title">
            客户中心
          </div>
          <ul data-v-24ee54cc="" class="nav-list">
            <li @click="current=0" data-v-24ee54cc="" :class="{current:current===0}"><span data-v-24ee54cc="">客户信息</span><i data-v-24ee54cc="" class="el-icon-arrow-right"></i></li>
            <li @click="current=1" data-v-24ee54cc="" :class="{current:current===1}"><span data-v-24ee54cc="">客户绑定</span><i data-v-24ee54cc="" class="el-icon-arrow-right"></i></li>
          </ul>
        </div>
        <div v-if="current===0" class="main">

          <h1>修改资料</h1>
          <div data-v-c1d2eb64="" class="main">
            <div data-v-c1d2eb64="">
              <div data-v-c1d2eb64="" class="titWrap"><i data-v-c1d2eb64="" class="titCircle"></i> <span data-v-c1d2eb64="" class="tit">办理流程</span> <span data-v-c1d2eb64=""
                                                                                                                                                          class="tit_tip">需要身份认证才能继续</span></div>
              <div data-v-c1d2eb64="" class="scanFace-tip"><i data-v-c1d2eb64="" class="el-icon-info tipIcon"></i> <span data-v-c1d2eb64="" class="tipText">请输入验证信息</span></div>
              <div data-v-c1d2eb64="">
                <form data-v-c1d2eb64="" class="el-form">
                  <div data-v-c1d2eb64="" class="main_infos">
                    <div data-v-c1d2eb64="" class="el-row">
                      <div data-v-c1d2eb64="" class="customer_num el-col el-col-7">客户编号</div>
                      <div data-v-c1d2eb64="" class="el-col el-col-15">
                        <div data-v-c1d2eb64="" class="el-form-item greyInpWrap">
                          <!---->
                          <div class="el-form-item__content">
                            <div data-v-c1d2eb64="" class="removeNumInp el-input">
                              <!----><input type="text" autocomplete="off" maxlength="10" placeholder="10位客户编号" class="el-input__inner">
                              <!---->
                              <!---->
                              <!---->
                              <!---->
                            </div>
                            <!---->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-v-c1d2eb64="" class="customer_types">
                    <div data-v-c1d2eb64="" class="el-row">
                      <div data-v-c1d2eb64="" class="customer_num el-col el-col-8">
                        <div data-v-c1d2eb64="" class="el-form-item">
                          <!---->
                          <div class="el-form-item__content">
                            <div data-v-c1d2eb64="" class="el-select el-select--medium">
                              <!---->
                              <div class="el-input el-input--medium el-input--suffix">
                                <!----><input type="text" readonly="readonly" autocomplete="off" placeholder="请选择" class="el-input__inner">
                                <!----><span class="el-input__suffix"><span class="el-input__suffix-inner"><i class="el-select__caret el-input__icon el-icon-arrow-up"></i>
                                <!---->
                                <!---->
                                <!---->
                                <!---->
                                <!---->
                                  </span>
                                <!---->
                                </span>
                                <!---->
                                <!---->
                              </div>
                              <div class="el-select-dropdown el-popper" style="display: none; min-width: 200px;">
                                <div class="el-scrollbar" style="">
                                  <div class="el-select-dropdown__wrap el-scrollbar__wrap" style="margin-bottom: -5px; margin-right: -5px;">
                                    <ul class="el-scrollbar__view el-select-dropdown__list">
                                      <!---->
                                      <li data-v-c1d2eb64="" class="el-select-dropdown__item selected"><span>客户名</span></li>
                                      <li data-v-c1d2eb64="" class="el-select-dropdown__item"><span>客户身份证号</span></li>
                                      <li data-v-c1d2eb64="" class="el-select-dropdown__item"><span>委托付款人名</span></li>
                                      <li data-v-c1d2eb64="" class="el-select-dropdown__item"><span>委托付款人身份证号</span></li>
                                      <li data-v-c1d2eb64="" class="el-select-dropdown__item"><span>委托扣款银行账号</span></li>
                                    </ul>
                                  </div>
                                  <div class="el-scrollbar__bar is-horizontal">
                                    <div class="el-scrollbar__thumb" style="transform: translateX(0%);"></div>
                                  </div>
                                  <div class="el-scrollbar__bar is-vertical">
                                    <div class="el-scrollbar__thumb" style="transform: translateY(0%);"></div>
                                  </div>
                                </div>
                                <!---->
                              </div>
                            </div>
                            <!---->
                          </div>
                        </div>
                      </div>
                      <div data-v-c1d2eb64="" class="el-col el-col-14">
                        <div data-v-c1d2eb64="">
                          <div data-v-c1d2eb64="" class="el-form-item">
                            <!---->
                            <div class="el-form-item__content">
                              <div data-v-c1d2eb64="" class="removeNumInp el-input">
                                <!----><input type="text" autocomplete="off" placeholder="请输入客户名" class="el-input__inner">
                                <!---->
                                <!---->
                                <!---->
                                <!---->
                              </div>
                              <!---->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div data-v-c1d2eb64="" class="greyBtnWrap"><button data-v-c1d2eb64="" disabled="disabled" type="button" class="el-button el-button--primary is-disabled">
                <!---->
                <!----><span>刷脸验证</span>
              </button></div>
            </div>
          </div>

        </div>
        <div v-else class="main">
          <div data-v-f8701ba0="">
            <h1 data-v-f8701ba0="">
              客户绑定
              <span data-v-f8701ba0="">绑定后可快速查询交费、办理业务</span>
            </h1>
            <div data-v-f8701ba0="" class="detail">
              <!---->
              <div data-v-f8701ba0="" class="section">
                <h4 data-v-f8701ba0="" class="mt10">请选择客户类型</h4>
                <div data-v-f8701ba0="" class="sec-content">
                  <div data-v-f8701ba0="">
                    <div data-v-c01d24b8="" data-v-f8701ba0="" class="bind-box show-more">
                      <div data-v-c01d24b8="" class="basic" @click="userType=0">
                        <label data-v-c01d24b8="" role="radio" tabindex="0" class="el-radio" aria-checked="true" :class="{'is-checked':userType===0}">
                          <span class="el-radio__input" :class="{'is-checked':userType===0}">
                            <span class="el-radio__inner"></span>
                            <input type="radio" aria-hidden="true" tabindex="-1" class="el-radio__original" value="true">
                          </span>
                          <span class="el-radio__label">个人用户 </span>
                        </label>
                        <div data-v-c01d24b8="" class="info"><span data-v-c01d24b8="">输入客户编号、身份证号或手机号</span> <i data-v-c01d24b8="" class="el-icon-arrow-right current"></i></div>
                      </div>
                      <div v-if="userType===0" data-v-c01d24b8="" class="more">
                        <div data-v-c01d24b8="" class="login-form">
                          <div data-v-c01d24b8="" class="el-input">
                            <!----><input type="text" autocomplete="off" placeholder="输入客户编号、身份证号或手机号" class="el-input__inner">
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                          <!---->
                        </div>
                        <div data-v-c01d24b8="" class="login-form"><button data-v-c01d24b8="" disabled="disabled" class="code-button">发送验证码</button>
                          <div data-v-c01d24b8="" class="el-input">
                            <!----><input type="text" autocomplete="off" placeholder="验证码" maxlength="6" class="el-input__inner">
                            <!---->
                            <!---->
                            <!---->
                            <!---->
                          </div>
                          <!---->
                        </div> <button data-v-c01d24b8="" disabled="disabled" type="button" class="el-button el-button--primary el-button--mini is-disabled">
                        <!---->
                        <!----><span>下一步</span>
                      </button>
                      </div>
                    </div>
                  </div>
                  <div data-v-f8701ba0="">
                    <div data-v-c01d24b8="" data-v-f8701ba0="" class="bind-box show-more">
                      <div data-v-c01d24b8="" class="basic" @click="userType=1">
                        <label data-v-c01d24b8="" role="radio" tabindex="0" class="el-radio" :class="{'is-checked':userType===1}">
                          <span class="el-radio__input" :class="{'is-checked':userType===1}">
                            <span class="el-radio__inner"></span>
                            <input type="radio" aria-hidden="true" tabindex="-1" class="el-radio__original" value="true">
                          </span>
                          <span class="el-radio__label">单位用户</span>
                        </label>
                        <div data-v-c01d24b8="" class="info"><span data-v-c01d24b8="">输入客户编号、纳税人识别号</span> <i data-v-c01d24b8="" class="el-icon-arrow-right"></i></div>
                      </div>
                      <div data-v-c01d24b8="" class="more" v-if="userType===1">
                        <div data-v-c01d24b8="" class="login-form">
                          <div data-v-c01d24b8="" class="el-input">
                            <input type="text" autocomplete="off" placeholder="输入客户编号、纳税人识别号" class="el-input__inner">
                          </div>
                        </div>
                        <div data-v-c01d24b8="" class="login-form"><button data-v-c01d24b8="" disabled="disabled" class="code-button">发送验证码</button>
                          <div data-v-c01d24b8="" class="el-input">
                            <input type="text" autocomplete="off" placeholder="验证码" maxlength="6" class="el-input__inner">
                          </div>
                        </div> <button data-v-c01d24b8="" disabled="disabled" type="button" class="el-button el-button--primary el-button--mini is-disabled">
                        <span>下一步</span>
                      </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div data-v-f8701ba0="" class="notice">
                <p data-v-f8701ba0="">温馨提示</p>
                <p data-v-f8701ba0="">手机号码、身份证号、纳税人识别号为您曾在桐庐水务桐庐水务留存的信息。</p>
              </div>
            </div>
          </div>
        </div>
        <business-aside />
      </div>
    </div>
  </div>
</template>
<script>
import businessAside from '../components/aside'
import { mapMutations } from 'vuex';
export default {
  data() {
    return {
      current: 0,
      userType: 0,
    }
  },
  methods: {
    ...mapMutations({
      updateMember: 'setMember',
      updateShelf: 'updateShelf',
    }),
  },
  mounted() {
    // let res ={
    //   name:'鲍上',
    //   phone:17766269590
    // }
    // this.updateMember(res);
  },
  components: {
    businessAside,
  },
}
</script>